// @ts-nocheck
/**
 * RAWSPPLY — Shop Page & Product View Interactive Scripts
 * Ported from Raw-Supply (React) to Vanilla JS for Shopify OS 2.0
 */

document.addEventListener('DOMContentLoaded', () => {
  initCardInteractions();
});

// Re-init on Shopify section renders / infinite scroll loads
document.addEventListener('shopify:section:load', () => {
  initCardInteractions();
});

/* ----------------------------------------------------------------
   1. PRODUCT CARD INTERACTIONS (Grid / Collection Page)
   ---------------------------------------------------------------- */
function initCardInteractions() {
  /** @type {NodeListOf<HTMLElement>} */
  const cards = document.querySelectorAll('.raw-card-wrapper');

  cards.forEach((card) => {
    if (card.dataset.rawInit) return;
    card.dataset.rawInit = 'true';

    /** @type {HTMLImageElement | null} */
    const img = card.querySelector('.product-media-container img, .card-gallery img');
    /** @type {HTMLButtonElement | null} */
    const prevBtn = card.querySelector('.raw-card-nav-btn--prev');
    /** @type {HTMLButtonElement | null} */
    const nextBtn = card.querySelector('.raw-card-nav-btn--next');
    /** @type {HTMLElement | null} */
    const toast = card.querySelector('.raw-card-variant-toast');
    /** @type {HTMLAnchorElement | null} */
    const link = card.querySelector('.product-card__link');

    // Variant Cycling
    const variantsDataRaw = card.dataset.variants;
    if (variantsDataRaw && img) {
      try {
        const variants = JSON.parse(variantsDataRaw);
        if (Array.isArray(variants) && variants.length > 1) {
          let currentIndex = 0;

          /** @param {number} index */
          const updateVariant = (index) => {
            currentIndex = (index + variants.length) % variants.length;
            const variant = variants[currentIndex];
            if (variant && variant.image) {
              img.src = variant.image;
              img.srcset = '';
            }
            if (toast && variant && variant.title) {
              toast.textContent = variant.title;
            }
            if (link && variant && variant.url) {
              link.href = variant.url;
            }
          };

          if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              updateVariant(currentIndex - 1);
            });
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              updateVariant(currentIndex + 1);
            });
          }
        }
      } catch (err) {
        console.warn('[RawSpply] Failed to parse variant data for card:', err);
      }
    }
  });
}



